module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/carementor.6960cf62.svg";